import React, { createContext, useState } from "react";

export const LibraryContext = createContext();

export const LibraryProvider = ({ children }) => {

  const [count, setCount] = useState(1);
  const [level, setLevel] = useState(null);
  const [topics, setTopics] = useState([]);
  const [topic, setTopic] = useState(null);
  const [reset, setReset] = useState(false);
  const [userInput, setUserInp] = useState({});
  const [topicList, setTopicList] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [handleadd, setHandleadd] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sharedTopics, setSharedTopics] = useState([]);
  const [complexities, setComplexities] = useState([]);
  const [alreadySelected, setAlreadySelected] = useState(null);
  const [isSelectedTopic, setIsSelectedTopic] = useState(true);
  const [topicAndComplexity, setTopicAndComplexity] = useState([]);
  const [filterSharedTopics, setFilterSharedTopics] = useState([]);
  const [alreadySelectedCom, setAlreadySelectedCom] = useState(null);
  const [isSelectedComplexity, setIsSelectedComplexity] = useState(true);
  const [dataTopicAndComplexity, setDataTopicAndComplexity] = useState([]);
  const [selectedScope, setSelectedScope] = useState("all");

  const [selectedTopic, setSelectedTopic] = useState(null);

  const [subjects, setSubjects] = useState([]);
  const [ccTestData, setCcTestData] = useState({
    qnId: null,
    topicId: null,
    ccWithFixedQn: false,
  });

  const [selectedSubject, setSelectedSubject] = useState({
    subId: "",
    subName: ""
  });

  const [editCodingCategories, setEditCodingCategories] = useState(false);
  const [openQuestionModal, setOpenQuestionModal] = useState(false);
  const [addSectionModal, setAddSectionModal] = useState(false);
  const [sectionName, setSectionName] = useState("");


  return (
    <LibraryContext.Provider
      value={{
        count,
        reset,
        level,
        topic,
        topics,
        setCount,
        setLevel,
        setTopic,
        setReset,
        userInput,
        setTopics,
        topicList,
        handleadd,
        activeStep,
        setUserInp,
        searchText,
        currentPage,
        setTopicList,
        complexities,
        sharedTopics,
        setHandleadd,
        setActiveStep,
        setSearchText,
        selectedTopic,
        setCurrentPage,
        setSharedTopics,
        alreadySelected,
        isSelectedTopic,
        setComplexities,
        setSelectedTopic,
        setAlreadySelected,
        setIsSelectedTopic,
        filterSharedTopics,
        alreadySelectedCom,
        topicAndComplexity,
        isSelectedComplexity,
        setTopicAndComplexity,
        setFilterSharedTopics,
        setAlreadySelectedCom,
        dataTopicAndComplexity,
        setIsSelectedComplexity,
        setDataTopicAndComplexity,
        selectedScope,
        setSelectedScope,
        subjects,
        setSubjects,
        ccTestData,
        setCcTestData,
        selectedSubject,
        setSelectedSubject,
        editCodingCategories,
        setEditCodingCategories,
        openQuestionModal,
        setOpenQuestionModal,
        addSectionModal,
        setAddSectionModal,
        sectionName, 
        setSectionName,
      }}
    >
      {children}
    </LibraryContext.Provider>
  );
};
